import { reactive } from 'vue';

const state = reactive({
  items: [],
});

function add({ type = 'info', message = '', duration = 3500 } = {}) {
  const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const toast = {
    id,
    type,
    message,
    duration,
  };

  state.items.push(toast);

  if (duration !== 0) {
    window.setTimeout(() => remove(id), duration);
  }

  return id;
}

function remove(id) {
  const idx = state.items.findIndex((t) => t.id === id);
  if (idx !== -1) state.items.splice(idx, 1);
}

export const notify = {
  state,
  add,
  remove,
  success(message, options = {}) {
    return add({ ...options, type: 'success', message });
  },
  error(message, options = {}) {
    return add({ ...options, type: 'error', message });
  },
  warning(message, options = {}) {
    return add({ ...options, type: 'warning', message });
  },
  info(message, options = {}) {
    return add({ ...options, type: 'info', message });
  },
};

export default {
  install(app) {
    app.config.globalProperties.$notify = notify;
    app.provide('notify', notify);
  },
};
